import Loading from '@/common/components/atom/loading';
import type { SVGProps } from 'react';

export type Icon17IconProps = SVGProps<SVGSVGElement> & { title?: string };

// Keep existing imports and layout classes while sharing the patient loading indicator.
export function Icon17Icon(props: Icon17IconProps) {
  return <Loading width="1em" height="1em" {...props} />;
}

export default Icon17Icon;
